/**
 * Error translation utility for converting English API error messages to Bulgarian
 */

// Map of English error messages to Bulgarian translations
const errorTranslations: Record<string, string> = {
  // Registration errors
  'A user with this email already exists': 'Потребител с този имейл вече съществува',
  'Password does not meet requirements': 'Паролата не отговаря на изискванията',

  // Authentication errors
  'Invalid email or password': 'Невалиден имейл или парола',
  'Please confirm your email before logging in': 'Моля, потвърдете имейла си преди да влезете',
  'Invalid credentials': 'Невалидни данни за вход',
  'Login failed': 'Неуспешен вход',
  'Authentication Failed': 'Неуспешна автентикация',

  // Email confirmation errors
  'Invalid confirmation code': 'Невалиден код за потвърждение',
  'Confirmation code has expired. Please request a new one.': 'Кодът за потвърждение е изтекъл. Моля, поискайте нов.',

  // Password reset errors
  'No user found with this email': 'Не е намерен потребител с този имейл',
  'Invalid verification code': 'Невалиден код за верификация',
  'Verification code has expired. Please request a new one.': 'Кодът за верификация е изтекъл. Моля, поискайте нов.',

  // Password change errors
  'Current password is incorrect': 'Текущата парола е грешна',
  'Too many requests. Please try again later.': 'Твърде много заявки. Моля, опитайте отново по-късно.',

  // Payment/TeleChat errors (409 Conflict)
  'Payment not authorized': 'Плащането не е оторизирано. Моля, завършете плащането първо.',
  'Resource already exists or constraint violation': 'Вече имате активна консултация с този лекар.',

  // Generic errors
  'Connection error': 'Грешка при свързване със сървъра',
  'Internal Server Error': 'Вътрешна грешка на сървъра',
  'Failed to register user with Cognito': 'Грешка при регистрация',
  'Failed to confirm email': 'Грешка при потвърждение на имейл',
  'Failed to resend confirmation code': 'Грешка при изпращане на код за потвърждение',
  'Failed to initiate password reset': 'Грешка при заявка за нова парола',
  'Failed to reset password': 'Грешка при смяна на парола',
  'Failed to change password': 'Грешка при промяна на парола',
};

/**
 * Translates an English error message to Bulgarian
 * @param englishMessage - The English error message from the API
 * @returns The Bulgarian translation or a generic error message
 */
export function translateError(englishMessage: string): string {
  if (!englishMessage) {
    return 'Възникна грешка. Моля, опитайте отново.';
  }

  // Check for exact match
  if (errorTranslations[englishMessage]) {
    return errorTranslations[englishMessage];
  }

  // Check for partial matches (for messages that include dynamic content)
  for (const [key, value] of Object.entries(errorTranslations)) {
    if (englishMessage.toLowerCase().includes(key.toLowerCase())) {
      return value;
    }
  }

  // Default fallback for unknown errors
  return 'Възникна грешка. Моля, опитайте отново.';
}

export default translateError;
